import React, { useState, useEffect } from "react";
import { FaMoon, FaSun } from "react-icons/fa";
import "./toggle.css";

const ThemeToggle = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);

  // Check for user's system preference
  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    const prefersDarkScheme = window.matchMedia("(prefers-color-scheme: dark)").matches;

    if (savedTheme === "dark" || (savedTheme === null && prefersDarkScheme)) {
      setIsDarkMode(true);
      document.body.classList.add("dark-mode");
    }
  }, []);

  const toggleTheme = () => {
    setIsDarkMode((prevMode) => {
      const newMode = !prevMode;
      if (newMode) {
        document.body.classList.add("dark-mode");
        localStorage.setItem("theme", "dark");
      } else {
        document.body.classList.remove("dark-mode");
        localStorage.setItem("theme", "light");
      }
      return newMode;
    });
  };

  return (
    <div className="theme-toggle" onClick={toggleTheme}>
      <div className={`toggle-container ${isDarkMode ? "dark" : "light"}`}>
        <span className={`toggle-icon ${isDarkMode ? "sun" : "moon"}`}>
          {isDarkMode ? <FaSun /> : <FaMoon />}
        </span>
        <div className={`toggle-knob`} />
      </div>
    </div>
  );
};

export default ThemeToggle;
